/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import PropTypes, { number } from 'prop-types';
import { Accordion } from 'ypf-pas-general-ui-components';

import MonthlyUbicationLinesContainer from '../MonthlyLinesContainer/MonthlyUbicationLinesContainer';
import {
  WorkPartPermissions,
  TypeAndObjectImputationPermissions,
  AttachedFilesPermissions
} from '../RequestDetailTypes';

import RightContentAccordion from './RightContentAccordion';
import LeftContentAccordion from './LeftContentAccordion';

import './CustomAccordion.scss';

const UbicationAccordion = ({
  accordionData,
  accordionsSelecteds,
  asignationType,
  byUbication,
  closeAccordions,
  disabledEditStateCancelOrFinish,
  handleOpenAccordion,
  hasPositionLines,
  IOPermissions,
  month,
  newLineAdded,
  setAccordionsSelecteds,
  setOpenModal,
  setRefreshFetch,
  setShowAddPLToUbicationModal,
  workPartPermissions,
  year,
  setShowDeleteModal,
  handleUpdateLocationData,
  isTemplate,
  updateDeleteUbicationInfo,
  ubicationIndex,
  filesPermissions,
  search,
  isOyM,
  requestData,
  setShowFinishedServiceModal,
  showFinishedServiceModal,
  isFinishedServiceAvailable,
  setFinishedServiceInfo,
  notificaPP
}) => {
  const [showContentAccordion, setShowContentAccordion] = useState(false);
  const [isFinishedServiceUsable, setIsFinishedServiceUsable] = useState({});
  const isUbicationSelected = () => accordionsSelecteds.includes(accordionData?.id);

  const handleOnChange = () => {
    setAccordionsSelecteds(
      isUbicationSelected()
        ? accordionsSelecteds.filter((id) => id !== accordionData?.id)
        : [...accordionsSelecteds, accordionData?.id]
    );
  };

  const onClickImputationObject = () => {
    setOpenModal(accordionData);
  };

  const getFinishedServiceAvailability = async () => {
    const response = await isFinishedServiceAvailable(accordionData?.id);

    setIsFinishedServiceUsable({
      habilitaFinalizacion: response?.habilitaFinalizacion,
      detalleLocacion: response?.detalleLocacion
    });
  };

  useEffect(() => {
    getFinishedServiceAvailability();
    handleOpenAccordion(showContentAccordion, accordionData?.id);
  }, [showContentAccordion]);

  useEffect(() => {
    if (closeAccordions) {
      setShowContentAccordion(false);
    }
  }, [closeAccordions]);

  const handleUpdateDeleteUbicationInfo = () => {
    updateDeleteUbicationInfo(accordionData.id, accordionData.nombre);
  };

  const handleSetFinishedServiceInfo = () => {
    setFinishedServiceInfo({ ...accordionData, isFinishedServiceUsable });
  };

  return (
    <div className="custom-accordion">
      <Accordion
        availableManualOpening
        leftContent={
          <LeftContentAccordion
            accordionData={accordionData}
            equipmentName={accordionData?.nombreEquipo}
            hasTechnicalLocations={isOyM}
            id={accordionData?.id}
            isChecked={isUbicationSelected()}
            isTemplate={isTemplate}
            onChange={handleOnChange}
            requestData={requestData}
            typeEvent={accordionData?.tipoEvento}
            ubicationName={accordionData?.nombre}
          />
        }
        restrictedOpening
        rightContent={
          <RightContentAccordion
            IOPermissions={IOPermissions}
            byUbication={byUbication}
            disabledDeleteAction={
              !workPartPermissions.deleteUbication || disabledEditStateCancelOrFinish
            }
            handleSetFinishedServiceInfo={handleSetFinishedServiceInfo}
            handleUpdateDeleteUbicationInfo={handleUpdateDeleteUbicationInfo}
            isFinishedServiceAvailable={
              isFinishedServiceUsable?.habilitaFinalizacion && !accordionData?.finalizada
            }
            isOrderByUbication
            setOpenModal={onClickImputationObject}
            setShowDeleteModal={setShowDeleteModal}
            setShowFinishedServiceModal={setShowFinishedServiceModal}
            showFinishedServiceModal={showFinishedServiceModal}
          />
        }
        setShowManualContent={setShowContentAccordion}
        showManualContent={showContentAccordion}
        width="100%"
      >
        <MonthlyUbicationLinesContainer
          accordionData={accordionData}
          asignationType={asignationType}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          filesPermissions={filesPermissions}
          handleUpdateLocationData={handleUpdateLocationData}
          hasPermissionsToAddLines={workPartPermissions.addPositionLine}
          hasPositionLines={hasPositionLines}
          isOyM={isOyM}
          isTemplate={isTemplate}
          month={month}
          newLineAdded={newLineAdded}
          notificaPP={notificaPP}
          positionLinePermissions={workPartPermissions.positionLine}
          search={search}
          setAccordionsSelecteds={setAccordionsSelecteds}
          setRefreshFetch={setRefreshFetch}
          setShowAddPLToUbicationModal={setShowAddPLToUbicationModal}
          showContentAccordion={showContentAccordion}
          ubicationIndex={ubicationIndex}
          year={year}
        />
      </Accordion>
    </div>
  );
};

UbicationAccordion.propTypes = {
  accordionData: PropTypes.shape({
    nombre: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    idLocacion: PropTypes.number.isRequired,
    nombreEquipo: PropTypes.string.isRequired,
    fechasEvento: PropTypes.string.isRequired,
    tipoEvento: PropTypes.string.isRequired,
    finalizada: PropTypes.bool.isRequired
  }).isRequired,
  accordionsSelecteds: PropTypes.arrayOf(number).isRequired,
  asignationType: PropTypes.number.isRequired,
  byUbication: PropTypes.bool,
  closeAccordions: PropTypes.bool.isRequired,
  handleOpenAccordion: PropTypes.func.isRequired,
  hasPositionLines: PropTypes.bool.isRequired,
  IOPermissions: TypeAndObjectImputationPermissions.isRequired,
  month: PropTypes.string,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  newLineAdded: PropTypes.bool.isRequired,
  setAccordionsSelecteds: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func,
  setRefreshFetch: PropTypes.func,
  setShowAddPLToUbicationModal: PropTypes.func.isRequired,
  workPartPermissions: WorkPartPermissions.isRequired,
  year: PropTypes.string,
  setShowDeleteModal: PropTypes.func.isRequired,
  setShowFinishedServiceModal: PropTypes.func.isRequired,
  isFinishedServiceAvailable: PropTypes.func.isRequired,
  showFinishedServiceModal: PropTypes.bool.isRequired,
  setFinishedServiceInfo: PropTypes.func.isRequired,
  updateDeleteUbicationInfo: PropTypes.func.isRequired,
  handleUpdateLocationData: PropTypes.func,
  isTemplate: PropTypes.bool,
  ubicationIndex: PropTypes.number.isRequired,
  filesPermissions: AttachedFilesPermissions,
  search: PropTypes.string,
  isOyM: PropTypes.bool,
  requestData: PropTypes.shape({}),
  notificaPP: PropTypes.bool.isRequired
};

UbicationAccordion.defaultProps = {
  byUbication: false,
  setOpenModal: () => {
    /* empty */
  },
  setRefreshFetch: () => {
    /* empty */
  },
  month: '',
  year: '',
  isTemplate: false,
  handleUpdateLocationData: () => {},
  filesPermissions: {
    visualize: false,
    write: false
  },
  search: '',
  isOyM: false,
  requestData: {}
};

export default UbicationAccordion;
